// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-container[data-v-bbe5efb4]{display:flex;position:absolute;top:0;left:calc(var(--inner-width)*1px);z-index:99}.icon[data-v-bbe5efb4]{width:48px;margin:2px;cursor:pointer}.icon img[data-v-bbe5efb4]{width:100%}", ""]);
// Exports
module.exports = exports;
